import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SITE } from "../data/site";
import { MaskedLines, Reveal } from "./Reveal";

// Site-wide final conversion block.
export function CTABlock({ dark = true }) {
  return (
    <section className={`${dark ? "noise-dark text-zinc-100" : "bg-offwhite text-charcoal"} relative overflow-hidden`}>
      <div className={`absolute inset-0 ${dark ? "grid-lines-dark" : "grid-lines"}`} aria-hidden="true" />
      <div className="container-x relative py-24 md:py-36">
        <Reveal>
          <p className={dark ? "eyebrow-dark" : "eyebrow"}>Start with a technical survey — no obligation</p>
        </Reveal>
        <MaskedLines
          lines={["See your system.", "Then decide."]}
          className={`h-display mt-8 text-5xl sm:text-6xl lg:text-7xl ${dark ? "text-zinc-50" : "text-charcoal"}`}
          lineClassName=""
        />
        <Reveal delay={0.15}>
          <p className={`mt-8 max-w-xl text-base leading-relaxed md:text-lg ${dark ? "text-zinc-400" : "text-zinc-600"}`}>
            A DCC survey inspects the system, grades the condition with photographs, and tells you what the evidence supports. Scope follows evidence — never the other way around.
          </p>
        </Reveal>
        <Reveal delay={0.25}>
          <div className="mt-10 flex flex-wrap gap-4">
            <Link to={SITE.cta.to} data-testid="cta-block-survey-btn" className="btn-primary">
              {SITE.cta.label}
              <ArrowUpRight size={16} aria-hidden="true" />
            </Link>
            <a href={`tel:${SITE.contact.phone.replace(/\s/g, "")}`} data-testid="cta-block-call-btn" className={`btn-ghost ${dark ? "text-zinc-200 hover:bg-zinc-100 hover:text-charcoal" : "text-charcoal hover:bg-charcoal hover:text-white"}`}>
              Call {SITE.contact.phone}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
